const includeInValidation = function(vm,condition){
    if(typeof condition === 'boolean'){
        return condition
    } else if(condition === 'useAlternateDeliveryAddress'){
        return vm['useAlternateDeliveryAddress']
    }
}

export default includeInValidation